import { render, staticRenderFns } from "./index.vue?vue&type=template&id=638562b0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638562b0",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WDateTime from '@/components/WDateTime.vue'
import WHtml from '@/components/WHtml.vue'
import WInput from '@/components/WInput.vue'
import WMoney from '@/components/WMoney.vue'
import WSelect from '@/components/WSelect.vue'
import WSwitch from '@/components/WSwitch.vue'
import WTextarea from '@/components/WTextarea.vue'
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WDateTime,WHtml,WInput,WMoney,WSelect,WSwitch,WTextarea,WTopBar})
